import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { tenant } from '@tenant';

import { AUTHENTICATION_BANNER_TEST_ID } from './constants';

export const AuthenticationBanner = () => (
  <div
    data-testid={AUTHENTICATION_BANNER_TEST_ID}
    className="flex items-center gap-2.5 rounded-md bg-highlight-surface px-4 py-[9px]"
  >
    <InformationCircleIcon className="size-5 shrink-0 text-content-primary" />
    <p className="text-sm leading-[18px] text-content-primary">
      Need to share access with a third party? Contact support at{' '}
      <a
        href={`mailto:${tenant.support.email}`}
        className="cursor-pointer underline hover:no-underline"
      >
        {tenant.support.email}
      </a>{' '}
      to request a restricted API key.
    </p>
  </div>
);
